import sm from "./structureMethods-helper";

export default{
  // order
  order_tab1_filter_data: [
    {
      title: '주문일자',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  order_tab1_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 140],
    ['product', '주문 상품', 240],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['pay_type', '결제수단', 100]
  ]),

  order_tab2_filter_data: [
    {
      title: '주문일자',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  order_tab2_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130],
    ['status_kor', '결제상태', 100]
  ]),

  pay_new_tab1_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '결제 수단',
      type: 'radiobutton',
      key: 'pay_type',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '신용카드', value:0},
        {label: '휴대폰결제', value:1},
        {label: '무통장입금', value:2},
        {label: '실시간 계좌이체', value:3},
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  pay_new_tab1_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 140],
    ['product', '주문 상품', 240],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['pay_type', '결제수단', 100]
  ]),

  pay_new_tab2_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '결제 수단',
      type: 'radiobutton',
      key: 'pay_type',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '신용카드', value:0},
        {label: '휴대폰결제', value:1},
        {label: '무통장입금', value:2},
        {label: '실시간 계좌이체', value:3},
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  pay_new_tab2_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130],
    ['status_kor', '결제상태', 100]
  ]),

  pay_all_tab1_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '상태',
      type: 'checkbox',
      key: 'status_list',
      value: [100,101,102,200,300,301,302,400],
      options: [
        {label: '입금 대기', value: 100},
        {label: '결제 완료', value: 101},
        {label: '주문 확정', value: 102},
        {label: '상품준비중', value: 200},
        {label: '배송대기', value: 300},
        {label: '배송중', value: 301},
        {label: '배송완료', value: 302},
        {label: '구매확정', value: 400},
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  pay_all_tab1_table_data: sm.tableData([
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 140],
    ['product', '주문 상품', 240],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['pay_type', '결제수단', 100]
  ]),

  pay_all_tab2_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '상태',
      type: 'checkbox',
      key: 'status_list',
      value: [100,101,102,200,300,301,302,400],
      options: [
        {label: '입금 대기', value: 100},
        {label: '결제 완료', value: 101},
        {label: '주문 확정', value: 102},
        {label: '상품준비중', value: 200},
        {label: '배송대기', value: 300},
        {label: '배송중', value: 301},
        {label: '배송완료', value: 302},
        {label: '구매확정', value: 400},
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  pay_all_tab2_table_data: sm.tableData([
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['status_kor', '주문상태', 100]
  ]),

  // goods
  goods_new_tab1_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '결제 수단',
      type: 'radiobutton',
      key: 'pay_type',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '신용카드', value:0},
        {label: '휴대폰결제', value:1},
        {label: '무통장입금', value:2},
        {label: '실시간 계좌이체', value:3},
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  goods_new_tab1_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 140],
    ['product', '주문 상품', 240],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['pay_type', '결제수단', 100]
  ]),


  goods_new_tab2_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '결제 수단',
      type: 'radiobutton',
      key: 'pay_type',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '신용카드', value:0},
        {label: '휴대폰결제', value:1},
        {label: '무통장입금', value:2},
        {label: '실시간 계좌이체', value:3},
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  goods_new_tab2_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 150],
    ['status_kor', '주문상태', 100]
  ]),

  goods_all_tab1_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '결제 수단',
      type: 'radiobutton',
      key: 'pay_type',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '신용카드', value:0},
        {label: '휴대폰결제', value:1},
        {label: '무통장입금', value:2},
        {label: '실시간 계좌이체', value:3},
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  goods_all_tab1_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 140],
    ['product', '주문 상품', 240],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['pay_type', '결제수단', 100]
  ]),


  goods_all_tab2_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '결제 수단',
      type: 'radiobutton',
      key: 'pay_type',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '신용카드', value:0},
        {label: '휴대폰결제', value:1},
        {label: '무통장입금', value:2},
        {label: '실시간 계좌이체', value:3},
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  goods_all_tab2_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 150],
    ['status_kor', '상태', 100]
  ]),

  // delivery
  delivery_new_tab1_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '송장번호 여부',
      type: 'radiobutton',
      key: 'is_invoice',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: "송장번호 입력", value: "false" },
        { label: "송장번호 미입력", value: "true" }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  delivery_new_tab1_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 140],
    ['product', '주문 상품', 240],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['pay_type', '결제수단', 100]
  ]),


  delivery_new_tab2_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '송장번호 여부',
      type: 'radiobutton',
      key: 'is_invoice',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: "송장번호 입력", value: "false" },
        { label: "송장번호 미입력", value: "true" }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  delivery_new_tab2_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['invoice', '송장번호', 150],
    ['delivery_company', '택배사', 150],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 150],
    ['status_kor', '상태', 100]
  ]),

  deliverying_tab1_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '송장번호 여부',
      type: 'radiobutton',
      key: 'is_invoice',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: "송장번호 입력", value: "false" },
        { label: "송장번호 미입력", value: "true" }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  deliverying_tab1_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 140],
    ['product', '주문 상품', 240],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['pay_type', '결제수단', 100]
  ]),


  deliverying_tab2_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '송장번호 여부',
      type: 'radiobutton',
      key: 'is_invoice',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: "송장번호 입력", value: "false" },
        { label: "송장번호 미입력", value: "true" }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  deliverying_tab2_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 140],
    ['product', '주문 상품', 240],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['pay_type', '결제수단', 100]
  ]),

  delivery_all_tab1_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '송장번호 여부',
      type: 'radiobutton',
      key: 'is_invoice',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: "송장번호 입력", value: "false" },
        { label: "송장번호 미입력", value: "true" }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  delivery_all_tab1_table_data: sm.tableData([
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 140],
    ['product', '주문 상품', 240],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['pay_type', '결제수단', 100]
  ]),


  delivery_all_tab2_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '송장번호 여부',
      type: 'radiobutton',
      key: 'is_invoice',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: "송장번호 입력", value: "false" },
        { label: "송장번호 미입력", value: "true" }
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  delivery_all_tab2_table_data: sm.tableData([
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['invoice', '송장번호', 150],
    ['delivery_company', '택배사', 150],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['status_kor', '상태', 100]
  ]),

  delivery_success_tab1_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  delivery_success_tab1_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 140],
    ['product', '주문 상품', 240],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['pay_type', '결제수단', 100]
  ]),


  delivery_success_tab2_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  delivery_success_tab2_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['invoice', '송장번호', 150],
    ['delivery_company', '택배사', 150],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태 변경', 150],
    ['status_kor', '상태', 100]
  ]),

  order_settle_tab1_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  order_settle_tab1_table_data: sm.tableData([
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 140],
    ['product', '주문 상품', 240],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['pay_type', '결제수단', 100]
  ]),


  order_settle_tab2_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  order_settle_tab2_table_data: sm.tableData([
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['point', '포인트', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['status_kor', '결제상태', 100]
  ]),

  // return
  return_new_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  return_new_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130],
    ['status_kor', '주문상태', 100]
  ]),

  returning_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  returning_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130],
    ['status_kor', '주문상태', 100]
  ]),

  return_all_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '상태',
      type: 'checkbox',
      key: 'status_list',
      value: [700,701,702,703,704,705],
      options: [
        {label: '반품 요청(승인 대기)', value: 700},
        {label: '반품 처리(수거 진행)', value: 701},
        {label: '반품검사중', value: 702},
        {label: '반품 검사 완료(환불 대기)', value: 703},
        {label: '반품 검사 완료(환불 보류)', value: 704},
        {label: '반품 완료(환불 완료)', value: 705}
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  return_all_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['status_kor', '주문상태', 100]
  ]),

  refund_new_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '상태',
      type: 'checkbox',
      key: 'status_list',
      value: [703,704],
      options: [
        {label: '환불 대기', value: 703},
        {label: '환불 보류', value: 704}
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  refund_new_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130],
    ['status_kor', '주문상태', 100]
  ]),

  refund_all_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: '',
      key: 'update'
    },
    {
      title: '환불 수단',
      type: 'checkbox',
      key: 'refund_method',
      value: [0,1],
      options: [
        {label: '현금', value: 0},
        {label: '카드 취소', value: 1}
      ]
    },
    /*{
      title: '상태',
      type: 'checkbox',
      key: 'status_list',
      value: [703,704],
      options: [
        {label: '환불 대기', value: 703},
        {label: '환불 보류', value: 704}
      ]
    },*/
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  refund_all_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['updated_time', '반품 요청 일시', 140],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['quantity', '반품 수량', 100],
    ['reason', '반품 사유', 100],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['total_price', '총 주문금액', 120],
    ['refund_price', '환불 금액', 100],
    ['status_kor', '상태', 100],
    ['refund_method', '환불 수단', 100]
  ]),

  // exchange
  exchange_new_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '상태',
      type: 'checkbox',
      key: 'status_list',
      value: [600,601],
      options: [
        {label: '교환 요청(승인 대기)', value: 600},
        {label: '교환 처리중(수거 진행)', value: 601}
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  exchange_new_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['reason', '교환 사유', 100],
    ['status_change', '상태 변경', 180],
    ['status_kor', '상태', 100]
  ]),

  exchange_all_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '상태',
      type: 'checkbox',
      key: 'status_list',
      value: [600,601,602,603,604,605,606,607,608,609],
      options: [
        {label: '교환 요청(승인대기)', value: 600},
        {label: '교환 처리중(수거진행)', value: 601},
        {label: '교환 검사중', value: 602},
        {label: '교환 검사 완료(교환대기)', value: 603},
        {label: '교환 검사 완료(교환보류)', value: 604},
        {label: '교환 상품 준비중', value: 605},
        {label: '교환 상품 배송 대기', value: 606},
        {label: '교환 배송중', value: 607},
        {label: '교환 배송 완료', value: 608},
        {label: '교환 구매 확정', value: 609}
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  exchange_all_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['reason', '교환 사유', 100],
    ['status_kor', '상태', 100]
  ]),

  exchanging_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  exchanging_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['reason', '교환 사유', 100],
    ['status_change', '교환 검사 완료 처리', 180],
    ['status_kor', '상태', 100]
  ]),

  exchange_goods_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  exchange_goods_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['reason', '교환 사유', 100],
    ['status_change', '상태 변경', 180],
    ['status_kor', '상태', 120]
  ]),

  exchange_settle_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  exchange_settle_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['invoice', '송장번호', 150],
    ['delivery_company', '택배사', 150],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['reason', '교환 사유', 100],
    ['status_kor', '상태', 100]
  ]),

  exchange_success_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '상태',
      type: 'checkbox',
      key: 'status_list',
      value: [603,604],
      options: [
        {label: '교환 대기', value: 603},
        {label: '교환 보류', value: 604}
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  exchange_success_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['reason', '교환 사유', 100],
    ['status_change', '상태 변경', 150],
    ['status_kor', '상태', 100]
  ]),

  exchange_delivery_new_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  exchange_delivery_new_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['invoice', '송장번호', 150],
    ['delivery_company', '택배사', 150],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['reason', '교환 사유', 100],
    ['status_change', '상태변경', 150],
    ['status_kor', '상태', 100]
  ]),

  exchange_delivery_all_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '상태',
      type: 'checkbox',
      key: 'status_list',
      value: [607,608],
      options: [
        {label: '교환 배송중', value: 607},
        {label: '교환 배송 완료', value: 608}
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  exchange_delivery_all_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['invoice', '송장번호', 150],
    ['delivery_company', '택배사', 150],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['reason', '교환 사유', 100],
    ['status_change', '상태변경', 150],
    ['status_kor', '상태', 100]
  ]),

  cancel_new_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '결제수단',
      type: 'radiobutton',
      key: 'pay_type',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '신용카드', value:0},
        {label: '휴대폰결제', value:1},
        {label: '무통장입금', value:2},
        {label: '실시간 계좌이체', value:3},
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  cancel_new_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['reason', '취소사유', 100],
    ['status_kor', '상태', 100],
    ['status_change', '상태 변경', 150],
  ]),

  cancel_all_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '결제수단',
      type: 'radiobutton',
      key: 'pay_type',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '신용카드', value:0},
        {label: '휴대폰결제', value:1},
        {label: '무통장입금', value:2},
        {label: '실시간 계좌이체', value:3},
      ]
    },
    {
      title: '상태',
      type: 'checkbox',
      key: 'status_list',
      value: [500,501,502,503,504],
      options: [
        {label: '취소 요청(승인대기)', value: 500},
        {label: '취소 요청(환불대기)', value: 501},
        {label: '취소 보류', value: 502},
        {label: '취소 완료(입금전 주문 취소)', value: 503},
        {label: '취소 완료(환불 완료)', value: 504},
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  cancel_all_table_data: sm.tableData([
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['product_price', '단가', 100],
    ['quantity', '수량', 75],
    ['delivery_price', '총 배송비', 100],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 120],
    ['partner', '파트너명', 100],
    ['pay_type', '결제수단', 100],
    ['reason', '취소사유', 100],
    ['status_kor', '상태', 100],
  ]),

  // 주문
  account_new_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '파트너명', value: 'partner_name' }
      ]
    }
  ],

  account_new_table_data: sm.tableData([
    ['partner_name', '파트너명', 120],
    ['created_time', '생성날짜', 120],
    ['expect_date', '정산 예상날짜', 120],
    ['min_price', '최소 금액', 120],
    ['total_price', '주문금액(A)', 120],
    ['comm_price', '수수료(B)', 100],
    ['coupon_price', '할인 부담 금액(C)', 120],
    ['delivery_cost', '배송비 부담 금액(D)', 140],
    ['point', '적립 공제 금액(E)', 140],
    ['acc_price', '정산할 금액', 120],
    ['history', '판매내역', 140],
    ['modify_delete', '완료', 120]
  ]),

  // 주문
  account_all_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '파트너명', value: 'partner_name' }
      ]
    }
  ],

  account_all_table_data: sm.tableData([
    ['acc_date', '정산날짜', 120],
    ['partner_name', '파트너명', 120],
    ['total_price', '주문금액(A)', 120],
    ['comm_price', '수수료(B)', 100],
    ['coupon_price', '할인 부담 금액(C)', 120],
    ['delivery_cost', '배송비 부담 금액(D)', 140],
    ['point', '적립 공제 금액(E)', 140],
    ['acc_price', '정산할 금액', 120],
    ['history', '판매내역', 140]
  ]),
}
